import { render, staticRenderFns } from "./InspectionFormNotesList.vue?vue&type=template&id=9dbfeac2"
import script from "./InspectionFormNotesList.vue?vue&type=script&lang=js"
export * from "./InspectionFormNotesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports